module.exports = __webpack_public_path__ + "static/img/noticia3.447535d8.jpeg";